import { z } from 'zod'

export const TaxRoundingStrategySchema = z.enum(['ceil', 'round'])
export const DEFAULT_TAX_ROUNDING_STRATEGY = 'ceil'
export type TaxRoundingStrategy = z.infer<typeof TaxRoundingStrategySchema>

export const TaxConfigurationSchema = z.object({
  roundingStrategy: TaxRoundingStrategySchema,
})

export type TaxConfiguration = z.infer<typeof TaxConfigurationSchema>
